import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import ArrowRight from '@material-ui/icons/ArrowRightAlt';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Tooltip } from '@material-ui/core';
import { Box, Paper } from '@material-ui/core';

const SimpleList = ({ data, action, changeTitle }) => {
	const renderOrganos = (organos, paddingLeft = 10, action) => {
		return organos.map((organo) => (
			<>
				<ListItem style={{ paddingLeft: paddingLeft }} key={organo.id}>
					<ArrowRight
						color={'primary'}
						fontSize="large"
						style={{ marginRight: 10 }}
					/>
					<ListItemText primary={`${organo.nombre}`} />
					{action && (
						<ListItemSecondaryAction>
							<IconButton
								onClick={() => action(organo)}
								edge="end"
								aria-label="ver"
							>
								<VisibilityIcon />
							</IconButton>
						</ListItemSecondaryAction>
					)}
				</ListItem>
				{organo.organos &&
					organo.organos.length > 0 &&
					renderOrganos(organo.organos, paddingLeft + 30, action)}
			</>
		));
	};
	return (
		<Paper>
			<Box padding={3}>
				<h3>
					{changeTitle === true
						? 'Órganos Colegiados'
						: 'Órganos Colegiados Asignados'}
				</h3>
				<List component="nav">
					{data.map((d, key, ind) => (
						<div key={d.id}>
							<ListItem style={{ paddingLeft: 0 }} key={key}>
								<ArrowRight
									color="secondary"
									fontSize="large"
									style={{ marginRight: 10 }}
								/>
								<ListItemText primary={`${d.nombre}`} />
								{action && (
									<ListItemSecondaryAction>
										<Tooltip title="Ver Detalle">
											<IconButton
												onClick={() => action(d)}
												edge="end"
												aria-label="ver"
											>
												<VisibilityIcon />
											</IconButton>
										</Tooltip>
									</ListItemSecondaryAction>
								)}
							</ListItem>

							{/* Verifica si el objeto tiene 'organos' y llama a la función recursiva */}
							{d.organos &&
								d.organos.length > 0 &&
								renderOrganos(d.organos, 50, action, ind)}
						</div>
					))}
				</List>
			</Box>
		</Paper>
	);
};

export default SimpleList;
